import type * as React from 'react';
import { post } from '@Domain/Api';
import type { SubjectPayload } from '@Application/Subjects/Actions/subjectFetched';
import subjectCreated, { type SubjectCreatedAction } from '@Application/Subjects/Actions/subjectCreated';
import subjectCreationFailed, {
	type SubjectCreationFailedAction,
} from '@Application/Subjects/Actions/subjectCreationFailed';
import type CreateSubject from '@Application/Subjects/Commands/CreateSubject';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectCreatedAction | SubjectCreationFailedAction;

export default (command: CreateSubject) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<SubjectPayload>(
				`${parameters.api.host}/api/facilities/${command.facilityId}/subjects`,
				command.toJSON(),
			);

			const action = subjectCreated(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectCreationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
